import React, { useImperativeHandle, useEffect } from 'react';
import { apiHolder as api } from 'api';
import './index.scss';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import HOCUploadAttachmentWithFiles from './HOCUploadAttachmentWithFiles';
import { doAddCloudAttachment, doAddNormalAttachment } from '@web-common/state/reducer/diskAttReducer';
import { getIn18Text } from 'api';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const UploadAttachment = React.forwardRef((props, ref) => {
    const { uploadAttachmentWithFiles } = props;
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const extraOperate = useAppSelector(state => state.mailReducer.currentMail.extraOperate);
    const extraOperateDone = useAppSelector(state => { var _a; return !!((_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.extraOperateDone); });
    const applyGenerateHide = useAppSelector(state => state.mailReducer.applyGenerateHide);
    const dispatch = useAppDispatch();
    const validateSize = (fileList, cloud = false) => {
        uploadAttachmentWithFiles(fileList, cloud);
    };
    useImperativeHandle(ref, () => ({
        upload: validateSize,
    }));
    useEffect(() => {
        var _a, _b;
        if (extraOperate === 'questionApply') {
            applyGenerateHide && applyGenerateHide();
            if (inElectron) {
                (_b = (_a = window.electronLib) === null || _a === void 0 ? void 0 : _a.fsManage) === null || _b === void 0 ? void 0 : _b.logsToArrayBuf().then(res => {
                    const { success, data, name, path } = res;
                    if (success && data && data.byteLength > 0) {
                        const logs = new File([data], name || '');
                        logs.filePath = path;
                        validateSize([logs]);
                    }
                }).catch(err => {
                    console.log(getIn18Text('DABAOSHANGCHUANSHI'), err);
                });
            }
        }
        if ((extraOperate === null || extraOperate === void 0 ? void 0 : extraOperate.includes('addCloudAtt')) && currentMailId) {
            if (!extraOperateDone) {
                const payloadStr = extraOperate.split('payload:')[1];
                const payloadItem = JSON.parse(payloadStr);
                if (typeof payloadItem === 'object') {
                    setTimeout(() => {
                        dispatch(doAddCloudAttachment({ fileDetail: payloadItem, mailId: currentMailId }));
                    }, 1500);
                }
                dispatch(mailActions.doChangeExtraOperateDone(currentMailId));
            }
        }
        if ((extraOperate === null || extraOperate === void 0 ? void 0 : extraOperate.includes('addNormalAtt')) && currentMailId) {
            if (!extraOperateDone) {
                const payloadStr = extraOperate.split('payload:')[1];
                const payloadItem = JSON.parse(payloadStr);
                if (Array.isArray(payloadItem)) {
                    setTimeout(() => {
                        dispatch(doAddNormalAttachment({ fileDetail: payloadItem, mailId: currentMailId }));
                    }, 1500);
                    return;
                }
                if (typeof payloadItem === 'object') {
                    setTimeout(() => {
                        dispatch(doAddNormalAttachment({ fileDetail: payloadItem, mailId: currentMailId }));
                    }, 1500);
                }
                dispatch(mailActions.doChangeExtraOperateDone(currentMailId));
            }
        }
    }, [currentMailId]);
    return React.createElement(React.Fragment, null);
});
export default HOCUploadAttachmentWithFiles(UploadAttachment);
